import type { PaletteColorOptions } from '@mui/material';
import type { ThemeOptionsBuilder } from '../../../../../types/theme';

const copyPrimaryColorFromThemes = (partnerThemes: ThemeOptionsBuilder[], defaultColor: PaletteColorOptions) =>
  partnerThemes.reduce((acc: PaletteColorOptions, p: ThemeOptionsBuilder) => {
    return { ...acc, ...p.palette?.primary };
  }, defaultColor);

export default copyPrimaryColorFromThemes;
